<mat-card>
  <mat-card-title>Discount Codes</mat-card-title>
  <mat-card-content>
    <div class="summary">
      <mat-card class="summary-item">
        <mat-card-subtitle>Discount Codes</mat-card-subtitle>
        <div class="summary-value">{{discountCodes}}</div>
      </mat-card>
      <mat-card class="summary-item">
        <mat-card-subtitle>Discount Codes with no Discount Set</mat-card-subtitle>
        <div class="summary-value">{{discountCodesWithNoDiscountSet}}</div>
      </mat-card>
      <mat-card class="summary-item">
        <mat-card-subtitle>Products</mat-card-subtitle>
        <div class="summary-value">{{products}}</div>
      </mat-card>
      <mat-card class="summary-item">
        <mat-card-subtitle>Products with No Discount Set</mat-card-subtitle>
        <div class="summary-value">{{productsWithNoDiscountSet}}</div>
      </mat-card>
    </div>
  </mat-card-content>
</mat-card>

<mat-card class="mt-16">
  <mat-card-title>Top 25 Suppliers with Products with No Discount Set</mat-card-title>
  <mat-card-content>
    <div class="table-container mat-elevation-z8" *ngIf="topSuppliers && topSuppliers.length; else noSuppliers">
      <mat-table [dataSource]="topSuppliers">

        <ng-container cdkColumnDef="Name">
          <mat-header-cell *cdkHeaderCellDef> Name </mat-header-cell>
          <mat-cell *cdkCellDef="let s"> {{s.Name}} </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="Currency">
          <mat-header-cell *cdkHeaderCellDef> Currency </mat-header-cell>
          <mat-cell *cdkCellDef="let s"> {{s.Currency}} </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="Products">
          <mat-header-cell *cdkHeaderCellDef> Products </mat-header-cell>
          <mat-cell *cdkCellDef="let s"> {{s.Products}} </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="ProductsWithNoDiscountSet">
          <mat-header-cell *cdkHeaderCellDef> Products With No Discount Set </mat-header-cell>
          <mat-cell *cdkCellDef="let s"> {{s.ProductsWithNoDiscountSet}} </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="['Name','Currency','Products','ProductsWithNoDiscountSet']"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: ['Name','Currency','Products','ProductsWithNoDiscountSet'];"></mat-row>
      </mat-table>
    </div>

    <ng-template #noSuppliers>
      <div class="no-data">No supplier data</div>
    </ng-template>
  </mat-card-content>
</mat-card>
